import {connect} from 'react-redux'
import Lbv2Toast from '../components/lbv2_toast'
import {hideToast, dismissRotateHint} from '../actions/toast_index'

const mapStateToProps = (state) => ({
  kind: state.toast.kind,
  nonce: state.toast.nonce,
})

const mapDispatchToProps = (dispatch) => ({
  onHide: () => dispatch(hideToast()),
  onDismiss: () => dispatch(dismissRotateHint()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Lbv2Toast)
